/**
 * MCP 服务器目录 API —— 只读，来自 MCPHub（经 alita-server /api/mcp/servers 代理）。
 * 供展示"可添加的 MCP server 列表"；app 从中挑选并手动添加到本地 mcp hub。
 */

import type { ApiResponse } from './authApi';

export interface McpCatalogServer {
  name: string;
  description: string;
  toolCount: number;
  status: string; // connected / disconnected
  transport?: string; // streamablehttp
  endpoint: string; // app 该连的 Alita 网关 per-server 地址（不含 userId）
}

class McpCatalogAPI {
  private baseURL = '/api/mcp';

  /**
   * 获取 MCPHub 现有的 server 列表（需登录）。
   * 后端已滤掉管理员禁用的 server，保留临时掉线的并带 status。
   */
  async listServers(token: string): Promise<ApiResponse<{ servers: McpCatalogServer[]; total: number }>> {
    const response = await fetch(`${this.baseURL}/servers`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || '获取 MCP 服务器列表失败');
    }
    return response.json();
  }
}

export const mcpCatalogAPI = new McpCatalogAPI();
